import React from 'react';
import logo from '../../../assets/svg/logo.svg';

const VaultLogo: React.FC = () => (
  <div className="text-center mb-4">
    <img alt="Audio Militia" src={logo} style={{ maxWidth: '80px' }} />
    <strong className="d-block w-100 text-center font-weight-bold text-light" style={{ fontSize: '1.2rem', marginTop: '0.5rem' }}>
      VAULT
    </strong>
  </div>
);

export default VaultLogo;
